<script setup>
import { computed, ref, watch, nextTick } from "vue";

import Modal from "@/components/Modal";
import UserForm from "../users/UserForm";

const props = defineProps(["user"]);

const modalOpen = ref(false);

function toggleModal() {
  modalOpen.value = !modalOpen.value;
}
</script>

<template>
  <div class="button" @click="modalOpen = true">Edit User</div>
  <Modal :active="modalOpen" @toggle="toggleModal">
    <UserForm :userProp="user"></UserForm>
  </Modal>
</template>

<style scoped lang="scss">
.button {
  display: inline-flex;
}
</style>
